/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */


import {RouterOutlet} from './directives/router_outlet';
/**
 * \@whatItDoes Contains all the router outlets created in a component.
 * 
 * \@stable
 */
export class RouterOutletMap {
/**
 * \@internal
 */
_outlets: {[name: string]: RouterOutlet} = {};
/**
 * Adds an outlet to this map.
 * @param {?} name
 * @param {?} outlet
 * @return {?}
 */
registerOutlet(name: string, outlet: RouterOutlet): void { this._outlets[name] = outlet; }
/**
 * Removes an outlet from this map.
 * @param {?} name
 * @return {?}
 */
removeOutlet(name: string): void { this._outlets[name] = /** @type {?} */(( undefined)); }
}

function RouterOutletMap_tsickle_Closure_declarations() {
/**
 * \@internal
 * @type {?}
 */
RouterOutletMap.prototype._outlets;
}

